import { axiosInstance } from "@src/utils/axios/AxiosProvider";

interface DataType {
  apiKey?: string;
  otp?: string;
  phone?: string;
}

export const saveSubmitOtp = async ({ apiKey, ...data }: DataType) => {
  const response = await axiosInstance.post<unknown>("/api/otp/submit", data, {
    headers: {
      "x-api-key": apiKey,
    },
  });
  return response.data;
};
